// extracted by mini-css-extract-plugin
export default {"scrollThin":"style_scrollThin__0oByv"};